import type { Market } from '@/libs/market/market';

export type FeatureFlagIdentity = {
  id: string;
  market: Market;
};

export type FeatureFlagContext = {
  userId: string;
  properties: {
    market: Market;
  };
};

/** Shared targeting shape used by both the browser SDK and the server proxy. */
export function getFeatureFlagContext(identity: FeatureFlagIdentity): FeatureFlagContext {
  return {
    userId: identity.id,
    properties: {
      market: identity.market,
    },
  };
}
